//import FieldSet, { Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
//import React from 'react';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import Dropbox from '../../Dropbox';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/esm/Form';
//import Container from 'react-bootstrap/esm/Container';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Antenna details component
 */
export default class AntennaDetails extends WLDInputComponent {

    constructor(props: {band: number, bandItem: string}) {
        super(props);
    }

    /**
     * Function is called when the antenna is changed
     * @param link  user's data
     * @param newData New data which has been selected
     * @param site it's a tag to define the site of the antenna (e.g. site 1, site 2...)
     */
    onChangeAntenna(link: Readonly<any>, newData: {}, site: string) {
        link.define("equipAntenna"+site, newData);
    }

    /**
     * Check if the space diversity is enabled
     * @param link 
     * @returns 
     */
    sdIsEnabled(link: Readonly<any>) {
        for (let i = 0; i < link[super.getKeyValue("equipConf")]?.features?.length; i++) {
            if(link[super.getKeyValue("equipConf")]?.features[i].idFeature == 4 && link[super.getKeyValue("equipConf")]?.features[i].mandatory) {
                return true;
            }
        }

        return link[super.getKeyValue("features")]?.includes("4")
    }

    
    render() {
        return (
        <>

            { this.props.band == 1 ?
                <SingleBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                    <SingleBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Site 1 antenna</Form.Label>
                                        <Dropbox uniqueKey="idAntenna" 
                                        displayInputKey="label" 
                                        showStartedKey={link?.edit}
                                        startedKey={link[super.getKeyValue("equipAntennaSite1")]?.idAntenna}
                                        values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")].antennas : []} 
                                        onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site1"))}
                                        />

                                        
                                    </Col>

                                    <Col xs={6}>
                                        <Form.Label>Site 2 antenna</Form.Label>
                                        <Dropbox 
                                        uniqueKey="idAntenna" 
                                        displayInputKey="label"
                                        showStartedKey={link?.edit}
                                        startedKey={link[super.getKeyValue("equipAntennaSite2")]?.idAntenna}
                                        values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")].antennas : []} 
                                        onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site2"))}
                                        />
                                    </Col>

                                    
                                </Row>

                                <Row>
        
                                    { this.sdIsEnabled(link) ?
                                    <>
                                        <Col xs={6}>
                                            <Form.Label>Site 1 antenna diversity</Form.Label>
                                            <Dropbox uniqueKey="idAntenna" 
                                            displayInputKey="label" 
                                            showStartedKey={link?.edit}
                                            startedKey={link[super.getKeyValue("equipAntennaSite1Div")]?.idAntenna}
                                            values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")].antennas : []} 
                                            onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site1Div"))}
                                            />
                                        </Col>

                                        <Col xs={6}>
                                            <Form.Label>Site 2 antenna diversity</Form.Label>
                                            <Dropbox 
                                            uniqueKey="idAntenna" 
                                            displayInputKey="label"
                                            showStartedKey={link?.edit}
                                            startedKey={link[super.getKeyValue("equipAntennaSite2Div")]?.idAntenna}
                                            values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")].antennas : []} 
                                            onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site2Div"))}
                                            />
                                        </Col>
                                    </>
                                    : <></> }
                                </Row>
                            </>
                        )}
                    </SingleBandLinkReferenceContext.Consumer>
                    </>
                )}
                </SingleBandLinkUserContext.Consumer>
            :
            <DualBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                    <DualBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                <Row>
                                    <Col>
                                        <Form.Label>Site 1 antenna</Form.Label>
                                        <Dropbox uniqueKey="idAntenna" 
                                        displayInputKey="label" 
                                        showStartedKey={link?.edit}
                                        startedKey={link[super.getKeyValue("equipAntennaSite1")]?.idAntenna}
                                        values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")].antennas : []} 
                                        onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site1"))}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Form.Label>Site 2 antenna</Form.Label>
                                        <Dropbox 
                                        uniqueKey="idAntenna" 
                                        displayInputKey="label"
                                        showStartedKey={link?.edit}
                                        startedKey={link[super.getKeyValue("equipAntennaSite2")]?.idAntenna}
                                        values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")].antennas : []} 
                                        onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site2"))}
                                        />
                                    </Col>  
                                </Row>

        
                                    { this.sdIsEnabled(link) ?
                                    <>
                                        <Row>
                                            <Col>
                                                <Form.Label>Site 1 antenna diversity</Form.Label>
                                                <Dropbox uniqueKey="idAntenna" 
                                                displayInputKey="label" 
                                                showStartedKey={link?.edit}
                                                startedKey={link[super.getKeyValue("equipAntennaSite1Div")]?.idAntenna}
                                                values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")].antennas : []} 
                                                onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site1Div"))}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Label>Site 2 antenna diversity</Form.Label>
                                                <Dropbox 
                                                uniqueKey="idAntenna" 
                                                displayInputKey="label"
                                                showStartedKey={link?.edit}
                                                startedKey={link[super.getKeyValue("equipAntennaSite2Div")]?.idAntenna}
                                                values={(linkRef.equipNorms != null && link[super.getKeyValue("equipFreq")] != null) ? link[super.getKeyValue("equipFreq")]?.antennas : []} 
                                                onChange={(newData) => this.onChangeAntenna(link, newData, super.getKeyValue("Site2Div"))}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                    : <></> }
                            </>
                        )}
                    </DualBandLinkReferenceContext.Consumer>
                    </>
                )}
            </DualBandLinkUserContext.Consumer>
            }
        </>
        );
    }

}